// extracted by mini-css-extract-plugin
export var Accordion = "Accordion-module--Accordion--608ee";
export var AccordionArrow = "Accordion-module--Accordion-arrow--1a41f";
export var AccordionArrowOpen = "Accordion-module--Accordion--arrowOpen--edb2f";
export var AccordionExpanded = "Accordion-module--Accordion--expanded--fa411";
export var AccordionTab = "Accordion-module--Accordion-tab--85435";
export var AccordionTabClose = "Accordion-module--Accordion-tabClose--f1494";
export var AccordionTabContent = "Accordion-module--Accordion--tabContent--61054";
export var AccordionTabLabel = "Accordion-module--Accordion-tabLabel--eb186";
export var bounce = "Accordion-module--bounce--8b87c";